.newsletterNotificationCard {
	@apply yst-mb-4 yst-border-primary-200 yst-border yst-relative yst-p-4 #{!important};

	.closeButton {
		@apply yst-absolute yst-right-4 yst-top-4 yst-cursor-pointer yst-text-slate-400 yst-bg-transparent yst-border-0 yst-p-0;

		svg {
			@apply yst-w-6 yst-h-6;
		}

		&:hover,
		&:focus {
			@apply yst-text-slate-600;
		}
	}

	.container {
		@apply yst-flex yst-gap-3 yst-m-0 #{!important};

		.icon {
			width: 17px;
			height: 17px;
		}

		.content {
			@apply yst-grow yst-max-w-5xl yst-space-y-3;
		}
	}

	.emailField {
		@apply yst-space-y-1 yst-max-w-lg;

		.emailLabel {
			@apply yst-text-sm yst-font-semibold yst-text-slate-700;
		}
	}

	.consentLabel {
		@apply yst-flex yst-items-start yst-gap-2 yst-text-sm;
	}

	.buttonContainer {
		@apply yst-flex yst-gap-2 yst-pt-1;

		button {
			padding: 6px 8px 6px 10px;
		}
	}

	.privacyLink {
		@apply yst-underline yst-text-blue-600;

		&:hover {
			@apply yst-text-blue-800;
		}
	}
}
